
export default {
    getName: (state) => state.name,
    getNextSeqCode: (state) => state.nextSeqCode,
    getActivityCategories: (state) => state.activityCategories,
}